import moment from './moment';
import { isNil, compact, uniqBy } from 'lodash';

export function isGif(url: string) {
  return `${url}`?.endsWith('.gif');
}

export const isVideo = (str = '') => {
  const splitedArray = str?.split('.');
  const lastValueOfArray = splitedArray?.[splitedArray.length - 1];
  if (['mp4', 'flv', 'm4a', '3gp', 'mkv', 'mov'].includes(lastValueOfArray))
    return true;
  return false;
};

export const getImageUrl = (image = '', width = 400, height = 0) => {
  // return image;
  if (isNil(image)) return '';
  if (isGif(image))
    return `${process.env.NEXT_PUBLIC_PHOTO_HOST || process.env.REACT_APP_PHOTO_HOST || ''}/${image}`;
  if (!image)
    return `${process.env.NEXT_PUBLIC_PHOTO_HOST || process.env.REACT_APP_PHOTO_HOST || ''}/${width}x${height}/dev/common/c45245e8-5d72-4cf6-8d03-d1a4891cf39b.jpeg`;
  return image &&
    (image.indexOf('http') > -1 ||
      image.indexOf('https') > -1 ||
      image.indexOf('/images/') > -1)
    ? image
    : `${process.env.NEXT_PUBLIC_PHOTO_HOST || process.env.REACT_APP_PHOTO_HOST || ''}/${width}x${height}/${image}`;
};
export const formatMoney = (
  num: number | string,
  digits = 3,
  currency = 'đ',
) => {
  if (!num) return `0 ${currency}`;
  if (Number.isNaN(num)) return `0 ${currency}`;
  const re = `\\B(?=(\\d{${digits}})+(?!\\d))`;
  return `${String(num).replace(new RegExp(re, 'g'), '.')} ${currency}`;
};

export const discountPercent = (
  priceBeforeDiscount: number | string,
  minPrice: number | string,
) => {
  return Math.floor(
    (1 - Number(minPrice) / Number(priceBeforeDiscount || 1)) * 100,
  );
};

export const formatTimeStr = (time: string) => {
  return moment(time).format('DD/MM/YYYY HH:mm');
};

export const formatDateStr = (time: string) => {
  return moment(time).format('DD/MM/YYYY');
};

export const formatHighlightStr = (title: string, highlightKeys: string[]) => {
  let formattedTitle = title;
  highlightKeys.forEach((key: string) => {
    formattedTitle = formattedTitle?.replace(
      key,
      `<span class="txt-highlight">${key}</span>`,
    );
  });
  return formattedTitle;
};

export const normalizePhone = (value: string, prevValue: string) => {
  if (value?.length === 3 && prevValue?.length === 2)
    return `84${value.replace('8', '').replace('4', '')}`;
  if (
    value?.length > 1 &&
    !/(^84|^840)+([0-9]{0,})\b/.test(value) &&
    /([35789][0-9]{0,})\b/.test(value)
  ) {
    return `84${value}`;
  }
  if (value?.length === 1 && value !== '8' && value !== '4')
    return `84${value}`;
  if (value?.length === 1 && prevValue?.length === 2) return prevValue || '84';
  if (value?.length <= 1) return '84';
  if (value?.startsWith('8484')) return value?.replace('8484', '84');
  return value;
};

export const changeStringNoSign = (alias: string) => {
  if (!alias) return null;
  let str = alias;
  str = str?.toLowerCase();
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ {2}|ặ|ẳ|ẵ/g, 'a');
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  // str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ {2}|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  str = str.replace(/đ|ð/g, 'd');
  return str;
};

export const sortCities = (data = [], key = 'name') => {
  const newData = [...data];
  const collator = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: 'base',
  });
  return uniqBy(
    compact([
      data.find((e) => e.id === 'HN_01'),
      data.find((e) => e.id === 'HCM'),
      data.find((e) => e.id === 'DN_01'),
      ...(newData?.sort((a, b) =>
        collator.compare(a[key]?.normalize('NFC'), b[key]?.normalize('NFC')),
      ) || []),
    ]),
    'id',
  );
};
